import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Materials_ds_material_packagings_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { materialId: number, fullTextSearch?: string }): 
  Promise<{ result: { MaterialId?: number, PackagingId?: number, AutogenerateSerialNumbers?: boolean, DimensionUomId?: number, Height?: number, IsOrderDefault?: boolean, Length?: number, PalletHigh?: number, PalletTie?: number, QuantityPrecisionScale?: number, ShippingVolume?: number, ShippingWeight?: number, StackableGroupId?: string, StackableHeight?: number, StackableLength?: number, StackableVolume?: number, StackableWidth?: number, SubPackagingQuantity?: number, UpcCode?: string, UseAsShippingContainer?: boolean, Volume?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number, Width?: number, Packaging?: { Id?: number, ShortName?: string }, DimensionsUom?: { Id?: number, Short_name?: string }, VolumeUom?: { Id?: number, Short_name?: string }, WeightUom?: { Id?: number, Short_name?: string }, SubPackaging?: { Id?: number, ShortName?: string }, Material?: { Id?: number, IsFinishedGood?: boolean, IsFixedLength?: boolean, IsFixedVolume?: boolean, IsFixedWeight?: boolean } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materialId)) {
      missingRequiredInParams.push('\'materialId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/datasources/ds_material_packagings_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { materialId: number, fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { MaterialId?: number, PackagingId?: number, AutogenerateSerialNumbers?: boolean, DimensionUomId?: number, Height?: number, IsOrderDefault?: boolean, Length?: number, PalletHigh?: number, PalletTie?: number, QuantityPrecisionScale?: number, ShippingVolume?: number, ShippingWeight?: number, StackableGroupId?: string, StackableHeight?: number, StackableLength?: number, StackableVolume?: number, StackableWidth?: number, SubPackagingQuantity?: number, UpcCode?: string, UseAsShippingContainer?: boolean, Volume?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number, Width?: number, Packaging?: { Id?: number, ShortName?: string }, DimensionsUom?: { Id?: number, Short_name?: string }, VolumeUom?: { Id?: number, Short_name?: string }, WeightUom?: { Id?: number, Short_name?: string }, SubPackaging?: { Id?: number, ShortName?: string }, Material?: { Id?: number, IsFinishedGood?: boolean, IsFixedLength?: boolean, IsFixedVolume?: boolean, IsFixedWeight?: boolean } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materialId)) {
      missingRequiredInParams.push('\'materialId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/datasources/ds_material_packagings_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { materialId: number, fullTextSearch?: string, $keys: { MaterialId?: number, PackagingId?: number }[] }): 
  Promise<{ result: { MaterialId?: number, PackagingId?: number, AutogenerateSerialNumbers?: boolean, DimensionUomId?: number, Height?: number, IsOrderDefault?: boolean, Length?: number, PalletHigh?: number, PalletTie?: number, QuantityPrecisionScale?: number, ShippingVolume?: number, ShippingWeight?: number, StackableGroupId?: string, StackableHeight?: number, StackableLength?: number, StackableVolume?: number, StackableWidth?: number, SubPackagingQuantity?: number, UpcCode?: string, UseAsShippingContainer?: boolean, Volume?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number, Width?: number, Packaging?: { Id?: number, ShortName?: string }, DimensionsUom?: { Id?: number, Short_name?: string }, VolumeUom?: { Id?: number, Short_name?: string }, WeightUom?: { Id?: number, Short_name?: string }, SubPackaging?: { Id?: number, ShortName?: string }, Material?: { Id?: number, IsFinishedGood?: boolean, IsFixedLength?: boolean, IsFixedVolume?: boolean, IsFixedWeight?: boolean } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materialId)) {
      missingRequiredInParams.push('\'materialId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/datasources/ds_material_packagings_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
